import { useState } from 'react'
import type SwiperCore from 'swiper'
import { Carousel } from '#app/shared/ui/data-display/carousel/Carousel.tsx'
import { SectionEyebrow } from '#app/shared/ui/data-display/SectionEyebrow.tsx'
import { Icon } from '#app/shared/ui/icons/Icon.tsx'
import { MainContainer } from '#app/shared/ui/layout/MainContainer.tsx'

type Testimonial = {
  rating: number
  text: string
  author: string
  city: string
  car: string
  link: string
}

const TESTIMONIALS: Testimonial[] = [
  {
    rating: 5,
    text: 'Muy buena atención y trato por parte de Octavio, toda la gestión de papeles súper rápido, el coche y el concesionario estaban impecables.',
    author: 'Andreu Santos',
    city: 'Valencia',
    car: 'Compró un Audi Q3 Sportback',
    link: 'https://share.google/V6GGk2mY35eVCzGoQ',
  },
  {
    rating: 5,
    text: 'Hemos comprado un Cupra Leon, y ha sido una auténtica maravilla, tanto por la atención de Manel, como el estado del coche. Que por cierto están todos los vehículos en maravilloso estado, súper recomendable la compra de un vehículo!',
    author: 'Alejandro Vallespir',
    city: 'Mallorca',
    car: 'Compró un Cupra León',
    link: 'https://share.google/STU9AzTjlHICvPyMF',
  },
  {
    rating: 5,
    text: 'Lo primero es dar gracias a Octavio, que fue la persona que me dio todas las facilidades habidas y por haber para la compraventa del coche. Abrió el concesionario en festivo en España para que me pudiera llevar el coche en el mismo día. El trato fue excelente y todas las dudas fueron resueltas con nota. El coche está literalmente como nuevo, si no fuera por el cuentakilómetros, no sabría que es de segunda mano. Con toda la incertidumbre que conlleva comprar un coche y hacer un desembolso grande, desde la primera interacción, se me transmitió mucha seguridad por su parte. Muy contento y agradecido!',
    author: 'Scott Bosch',
    city: 'Madrid',
    car: 'Compró un Mercedes-Benz Clase A',
    link: 'https://share.google/32icjjeecLAni0x1X',
  },
  {
    rating: 5,
    text: 'Acabo de comprar un Range Rover Sport y la experiencia con la profesionalidad del equipo de GamaOptima ha sido increible. Son de lo mejor que he visto en concesionarios, otro nivel',
    author: 'Andrés Garcia Castiella',
    city: 'Ibiza',
    car: 'Compró un Land Rover Range Sport',
    link: 'https://share.google/ZCqDqb4sxEPSgPmoQ',
  },
  {
    rating: 5,
    text: 'Tuvimos una experiencia fenomenal. Los coches son perfectos, sin algún defecto o complicaciones. Nos dieron todo la documentación necesaria, y nos habilitaron un descuento de primavera. Octavio, con su perfil claramente orientado a su trabajo, nos acompaño en todo el proceso con una actitud cercana y resolutiva, genero confianza desde el primer momento.',
    author: 'Erkan Saka',
    city: 'Barcelona',
    car: 'Compró un Mini Countryman',
    link: 'https://share.google/JfOy64o25BpshYh4m',
  },
  {
    rating: 5,
    text: 'Tuvimos una experiencia maravillosa comprando nuestro coche aquí. Manel se esmeró en ayudarnos, desde la exhaustiva prueba de conducción hasta la gestión de todo el papeleo y la ayuda para elegir el coche perfecto. La galería está impecable y el inventario está repleto de coches de alta calidad en excelentes condiciones. Agradecí mucho la amabilidad de Manel con respecto a la barrera del idioma. Además, la experiencia de recogida fue inolvidable (¡un auténtico espectáculo!) y los regalos extra fueron un detalle muy agradable. Muy recomendable si buscas un coche impecable y sin estrés.',
    author: 'Caner',
    city: 'Barcelona',
    car: 'Compró un BMW Series 1',
    link: 'https://share.google/p2I34ZYcUWgFtCIOS',
  },
  {
    rating: 5,
    text: 'Muy buena atencion y trato por parte de Octavi! Concesionario recien reformado con coches de muy buena calidad. Compra muy rapida y con muchas facilidades por parte de GamaOptima! Todo un placer 🚙',
    author: 'Xavi Fer',
    city: 'Barcelona',
    car: 'Compró un BMW X2',
    link: 'https://share.google/5WXI5W7pr7GunbcaJ',
  },
  {
    rating: 5,
    text: 'Excelente atención y detallismo. Octavio fue fabuloso de principio a fin. Muy profesional y recomiendo ampliamente comprar un auto aquí.',
    author: 'Scarlett Bolsover',
    city: 'Barcelona',
    car: 'Compró un Mini Countryman',
    link: 'https://share.google/KnliwgxNY5Fp3W5Tt',
  },
]

const StarRating = ({ rating }: { rating: number }) => (
  <div className="flex gap-1">
    {Array.from({ length: 5 }).map((_, i) => (
      <span
        key={i}
        className={`
          text-[20px]

          ${i < rating ? 'text-primary' : 'text-neutral-200'}
        `}
      >
        ★
      </span>
    ))}
  </div>
)

const TestimonialCard = ({ testimonial }: { testimonial: Testimonial }) => (
  <div
    className={`
      flex h-full flex-col rounded-lg border border-neutral-75 bg-neutral-25 p-6
      text-base-medium text-neutral-600
    `}
  >
    <div className="mb-4 flex items-center justify-between">
      <StarRating rating={testimonial.rating} />
      <a
        href={testimonial.link}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Ver reseña en Google"
        className={`
          flex h-6 w-6 items-center justify-center rounded-full bg-white
        `}
      >
        <img src="/img/Google.png" alt="Google" width={19} height={19} />
      </a>
    </div>
    <p className="mb-4">{testimonial.text}</p>
    <div>
      <p className="font-bold">
        {testimonial.author}{' '}
        <span className="font-normal">· {testimonial.city}</span>
      </p>
      <p className="mt-1">{testimonial.car}</p>
    </div>
  </div>
)

export const Testimonials = () => {
  const [swiper, setSwiper] = useState<SwiperCore | undefined>(undefined)

  const slides = TESTIMONIALS.map((testimonial, i) => (
    <TestimonialCard key={i} testimonial={testimonial} />
  ))

  return (
    <section
      className={`
        bg-white py-16

        lg:py-20
      `}
    >
      <MainContainer
        className={`
          px-4

          sm:px-6
        `}
      >
        <SectionEyebrow>La opinión de nuestros clientes</SectionEyebrow>
        <h2
          className={`
            mb-10 text-h3 text-primary-800

            lg:text-h2
          `}
        >
          Historias de clientes satisfechos
        </h2>

        <div className="relative">
          <Carousel
            className={`
              [&_.swiper-slide]:!h-auto

              [&_.swiper-wrapper]:!items-stretch
            `}
            slides={slides}
            slidesPerView={1}
            spaceBetween={16}
            loop
            breakpoints={{
              640: { slidesPerView: 2, spaceBetween: 16 },
              1024: { slidesPerView: 3, spaceBetween: 16 },
            }}
            swiper={swiper}
            setSwiper={setSwiper}
          />

          <button
            aria-label="Anterior"
            onClick={() => swiper?.slidePrev()}
            className={`
              absolute -left-4 top-1/2 z-10 flex h-9 w-9 -translate-y-1/2
              items-center justify-center rounded-full border border-neutral-75
              bg-white shadow-md

              hover:bg-neutral-25

              lg:-left-5
            `}
          >
            <Icon
              name="basic/chevron-left"
              size="16px"
              className="text-primary-800"
            />
          </button>

          <button
            aria-label="Siguiente"
            onClick={() => swiper?.slideNext()}
            className={`
              absolute -right-4 top-1/2 z-10 flex h-9 w-9 -translate-y-1/2
              items-center justify-center rounded-full border border-neutral-75
              bg-white shadow-md

              hover:bg-neutral-25

              lg:-right-5
            `}
          >
            <Icon
              name="basic/chevron-right"
              size="16px"
              className="text-primary-800"
            />
          </button>
        </div>
      </MainContainer>
    </section>
  )
}
